import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ContactUsComponent } from './contact-us/contact-us.component';
import { HomeComponent } from './home/home.component';
import { SiteDetailsComponent } from './site-details/site-details/site-details.component';

import { YourFavouritesComponent } from './your-favourites/your-favourites.component';
import { OurPartnersComponent } from './beachwatch-partners/our-partners/our-partners.component';
import { PartnerDetailsComponent } from './beachwatch-partners/partner-details/partner-details.component';

import { HowWeReportComponent } from './water-monitoring/how-we-report/how-we-report.component';
import { HowWeMonitorComponent } from './water-monitoring/how-we-monitor/how-we-monitor.component';
import { WaterQualityDataComponent } from './water-monitoring/water-quality-data/water-quality-data.component';
import { BeachwatchDataFeedsComponent } from './water-monitoring/beachwatch-data-feeds/beachwatch-data-feeds.component';
import { UserSubscriptionsComponent } from './user-subscriptions/user-subscriptions/user-subscriptions.component';
import { WaterMonitoringComponent } from './water-monitoring/water-monitoring.component';
import { WhatIsBeachwatchComponent } from './what-is-beachwatch/what-is-beachwatch.component';
import { AboutBeachwatchComponent } from './what-is-beachwatch/about-beachwatch/about-beachwatch.component';
import { SafeToSwimComponent } from './what-is-beachwatch/safe-to-swim/safe-to-swim.component';
import { ReportPollutionComponent } from './report-pollution/report-pollution.component';
import { ContentDataSourcesComponent } from './what-is-beachwatch/content-data-sources/content-data-sources.component';
import { WaterMonitoringLandingComponent } from './water-monitoring/water-monitoring-landing/water-monitoring-landing.component';
import { MonitoringWaterQualityComponent } from './water-monitoring/monitoring-water-quality/monitoring-water-quality.component';


const routes: Routes = [
	{
		path : "home", // no component route with children first child path is empty and component HomeComponent, effectively this is similar to specifying HomeComponent for the parent path
		children : [
			{
				path : "", 
				title : "Beachwatch",
				component : HomeComponent,
				data : {
					breadcrumbLabel : "Home"
				}				
			},
			// {
			// 	path : "siteDetails/:id",
			// 	component : SiteDetailsComponent
			// }						
		]
	},	
	{
		path : "whatIsBeachwatch",
		title : "Beachwatch - What is Beachwatch",
		component : WhatIsBeachwatchComponent,
		data : {
			breadcrumbLabel : ""
		},
		children : [
			{
				path : "aboutBeachwatch",
				title : "Beachwatch - About Beachwatch",
				component : AboutBeachwatchComponent,
				data : {
					breadcrumbLabel : "About Beachwatch"
				}
			},		
			{
				path : "safeToSwim",
				title : "Beachwatch - Is it safe to swim?",
				component : SafeToSwimComponent,
				data : {
					breadcrumbLabel : "Is it safe to swim?"
				}
			},
			{
				path : "contentDataSources",
				title : "Beachwatch - Content and data sources",
				component : ContentDataSourcesComponent,
				data : {
					breadcrumbLabel : "Content and data sources"
				}
			},				
			{
				path: "",
				title : "Beachwatch - About Beachwatch",
				redirectTo: "aboutBeachwatch",
				pathMatch: "full"
			}	
		]
	},
	{
		path : "waterMonitoring",
		title : "Beachwatch - Water monitoring",
		component : MonitoringWaterQualityComponent,
		children : 
		[
			{
				path : "",
				title : "Beachwatch - Water monitoring",
				component : WaterMonitoringLandingComponent,
				data : {
					breadcrumbLabel : "Water monitoring"
				}
			},
			{
				path : "",
				title : "Beachwatch - Water monitoring",
				component : WaterMonitoringComponent,
				data : {
					breadcrumbLabel : "Water monitoring"
				},
				children : [
					{
						path : "howWeMonitor",
						title : "Beachwatch - How we monitor?",
						component : HowWeMonitorComponent,
						data : {
							breadcrumbLabel : "How we monitor"
						}
					},			
					{
						path : "howWeReport",
						title : "Beachwatch - How we report?",
						component : HowWeReportComponent,
						data : {
							breadcrumbLabel : "How we report"
						}
					},
					{
						path : "waterQualityData",
						title : "Beachwatch - Download data",
						component : WaterQualityDataComponent,
						data : {
							breadcrumbLabel : "Water quality data"
						}
					},
					{
						path : "beachwatchDataFeeds",
						title : "Beachwatch - Data feeds",
						component : BeachwatchDataFeedsComponent,
						data : {
							breadcrumbLabel : "Beachwatch data feeds"
						}
					},
					{
						path: "",
						redirectTo: "howWeMonitor",
						title : "Beachwatch - How we monitor?",
						pathMatch: "full"
					}	
				]
			},
			// {
			// 	path: "",
			// 	redirectTo: "waterMonitoring",
			// 	title : "Beachwatch - Water monitoring",
			// 	pathMatch: "full"
			// }
		]
	},	
	
	{
		path : "beachwatchPartners",
		title : "Beachwatch - Beachwatch partners",
		data : {
			breadcrumbLabel : "Beachwatch partners"
		},				
		children : [
			{
				path : "", 
				component : OurPartnersComponent,
				title : "Beachwatch - Beachwatch partners",
				data : {
					breadcrumbLabel : "Beachwatch partners"
				} 
			},
			{
				path : ":id",
				component : PartnerDetailsComponent,
				// along with onSameUrlNavigation : 'reload' ( see router options below ) to force Angular to run guards and resolvers so that 
				// we can reload the beachwatch partner detail page from the same page with a different partner and the router state object is also available
				// have to use router events in the component to watch state object
				runGuardsAndResolvers: 'always',
				data : {
					breadcrumbLabel : "Partner details"
				}  
			}			
		]		
	},
	{
		path : "yourFavourites",
		title : "Beachwatch - Your favourites",
		component : YourFavouritesComponent,
		data : {
			breadcrumbLabel : "Your favourites"
		}
	},
	{
		path : "contactUs",
		title : "Beachwatch - Contact us",
		component : ContactUsComponent,
		data : {
			breadcrumbLabel : "Contact us"
		}
	},
	{
		path : "reportPollution",
		title : "Beachwatch - Report pollution",
		component : ReportPollutionComponent,
		data : {
			breadcrumbLabel : "Report pollution"
		}
	},
	{
		path : "userSubscriptions",
		title : "Beachwatch - Subscribe to Beachwatch",
		component : UserSubscriptionsComponent,
		data : {
			breadcrumbLabel : "Subscribe"
		}
	},	
	{
		path : "siteDetails/:id",
		title : "Beachwatch - Site details",
		component : SiteDetailsComponent,
		data : {
			breadcrumbLabel : "Site details"
		}
	},		
	{
		path: "**",
		title : "Beachwatch",
		redirectTo: "home",
		pathMatch: "full"
	}	
]

@NgModule({
	imports: [RouterModule.forRoot(routes, { anchorScrolling: 'enabled', scrollPositionRestoration : 'enabled', onSameUrlNavigation: 'reload' })],
	exports: [RouterModule],
})

export class AppRoutingModule {}

